import storage from '../../utils/storage'

const STORAGE_KEY = 'tr_v3_employees_real'
const STORAGE_RESIGNED = 'tr_v3_resigned_real'
const STORAGE_USERS = 'tr_v3_users_real'

export default {
  state: {
    employees: [],
    resignedEmployees: [],
    users: []
  },
  mutations: {
    SET_EMPLOYEES(state, list) {
      state.employees = list
      storage.set(STORAGE_KEY, list)
    },
    ADD_EMPLOYEE(state, emp) {
      state.employees.push(emp)
      storage.set(STORAGE_KEY, state.employees)
    },
    UPDATE_EMPLOYEE(state, emp) {
      const idx = state.employees.findIndex(e => e.employee_id === emp.employee_id)
      if (idx >= 0) {
        state.employees.splice(idx, 1, emp)
        storage.set(STORAGE_KEY, state.employees)
      }
    },
    DELETE_EMPLOYEE(state, id) {
      state.employees = state.employees.filter(e => e.employee_id !== id)
      storage.set(STORAGE_KEY, state.employees)
    },
    MARK_RESIGNED(state, { id, date, reason, observed_behaviors, behavior_details, suggestions, manager_email }) {
      const idx = state.employees.findIndex(e => e.employee_id === id)
      if (idx >= 0) {
        const emp = state.employees[idx]
        emp.employment_status = 2
        emp.resignation_date = date
        emp.resignation_reason = reason || ''
        emp.observed_behaviors = observed_behaviors || []
        emp.behavior_details = behavior_details || ''
        emp.suggestions = suggestions || ''
        emp.resigned_manager_email = manager_email || ''
        state.resignedEmployees.unshift({ ...emp })
        state.employees.splice(idx, 1)
        storage.set(STORAGE_KEY, state.employees)
        storage.set(STORAGE_RESIGNED, state.resignedEmployees)
      }
    },
    SET_RESIGNED(state, list) {
      state.resignedEmployees = list
      storage.set(STORAGE_RESIGNED, list)
    },
    ADD_RESIGNED(state, emp) {
      state.resignedEmployees.push(emp)
      storage.set(STORAGE_RESIGNED, state.resignedEmployees)
    },
    DELETE_RESIGNED(state, id) {
      state.resignedEmployees = state.resignedEmployees.filter(e => e.employee_id !== id)
      storage.set(STORAGE_RESIGNED, state.resignedEmployees)
    },
    RESTORE_EMPLOYEE(state, id) {
      const idx = state.resignedEmployees.findIndex(e => e.employee_id === id)
      if (idx >= 0) {
        const emp = { ...state.resignedEmployees[idx] }
        emp.employment_status = 1
        emp.resignation_date = ''
        emp.resignation_reason = ''
        emp.observed_behaviors = []
        emp.behavior_details = ''
        emp.suggestions = ''
        state.employees.push(emp)
        state.resignedEmployees.splice(idx, 1)
        storage.set(STORAGE_KEY, state.employees)
        storage.set(STORAGE_RESIGNED, state.resignedEmployees)
      }
    },
    SET_USERS(state, list) {
      state.users = list
      storage.set(STORAGE_USERS, list)
    },
    ADD_USER(state, user) {
      state.users.push(user)
      storage.set(STORAGE_USERS, state.users)
    },
    UPDATE_MANAGER_STATUS(state, { email, status }) {
      const user = state.users.find(u => u.email === email)
      if (user) {
        user.status = status
        storage.set(STORAGE_USERS, state.users)
      }
    },
    RESET_MANAGER_PASSWORD(state, { email }) {
      const user = state.users.find(u => u.email === email)
      if (user) {
        user.password = email
        user.is_first_login = true
        storage.set(STORAGE_USERS, state.users)
      }
    },
    UPDATE_MANAGER_PASSWORD(state, { email, password }) {
      const user = state.users.find(u => u.email === email)
      if (user) {
        user.password = password
        user.is_first_login = false
        storage.set(STORAGE_USERS, state.users)
      }
    }
  },
  getters: {
    allEmployees: state => state.employees,
    allResigned: state => state.resignedEmployees,
    employeeById: (state, getters, rootState) => id => {
      const taskId = rootState.tasks && rootState.tasks.currentTask && rootState.tasks.currentTask.task_id
      let list = state.employees
      if (taskId) {
        list = list.filter(e => e.task_id === taskId || !e.task_id)
      }
      return list.find(e => e.employee_id === id)
    },
    subordinatesByEmail: (state, getters, rootState) => email => {
      // 主管的下属列表不受 currentTask 限制——下属天然属于该主管
      return state.employees.filter(e => e.manager_email === email)
    },
    taskEmployees: (state, getters, rootState) => {
      const taskId = rootState.tasks && rootState.tasks.currentTask && rootState.tasks.currentTask.task_id
      if (!taskId) return state.employees
      return state.employees.filter(e => e.task_id === taskId || !e.task_id)
    },
    taskResigned: (state, getters, rootState) => {
      const taskId = rootState.tasks && rootState.tasks.currentTask && rootState.tasks.currentTask.task_id
      if (!taskId) return state.resignedEmployees
      return state.resignedEmployees.filter(e => e.task_id === taskId || !e.task_id)
    },
    departments: state => [...new Set(state.employees.map(e => e.dept_name).filter(Boolean))],
    allUsers: state => state.users,
    userByEmail: state => email => state.users.find(u => u.email === email)
  }
}
